import SizeFormView from "./SizeFormView";

function SizeForm({
  setPrinterData,
  selectedLabelItem,
  selectedLabelItemIndex,
  submitError,
}) {
  /**
   * This method will handle the on width change event.
   * @param {event} e
   */
  function onWidthChange(e) {
    setPrinterData((prev) => ({
      ...prev,
      label_items: prev.label_items.map((item, index) =>
        index === selectedLabelItemIndex
          ? {
              ...item,
              width: e.target.value,
            }
          : item
      ),
    }));
  }

  /**
   * This method will handle the on height change event.
   * @param {event} e
   */
  function onHeightChange(e) {
    setPrinterData((prev) => ({
      ...prev,
      label_items: prev.label_items.map((item, index) =>
        index === selectedLabelItemIndex
          ? {
              ...item,
              height: e.target.value,
            }
          : item
      ),
    }));
  }

  return (
    <SizeFormView
      selectedLabelItem={selectedLabelItem}
      selectedLabelItemIndex={selectedLabelItemIndex}
      onWidthChange={onWidthChange}
      onHeightChange={onHeightChange}
      submitError={submitError}
    />
  );
}

export default SizeForm;
